module.exports = __webpack_public_path__ + "img/logo-um-fe-ang.562d5cd5.png";